module.exports = __webpack_public_path__ + "files/c68af4c8c33c23ee1adae8ca98b325d0.png";